// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.repeat-section {
    border: 1px solid #11366b;
    padding: 20px;
    border-radius: 15px;
    margin-bottom: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/Core/Abstract/FormArray/repeat-section.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".repeat-section {\n    border: 1px solid #11366b;\n    padding: 20px;\n    border-radius: 15px;\n    margin-bottom: 18px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
